import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { getBIDSTencentQCouldMassage } from '@sg/services/cos';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

interface IPublishingReviewsDocPreviewerProps extends IBaseProps {
  // 预览文档的cos的存储的key
  doc_key: string;
  doc_name?: string;
  doc_suffix?: string;
  item_id?: string | number; // Project unified_id for project selection restoration
}

// Require login to view documents (ensures watermark is always applied)
const getAuth = async (): Promise<boolean> => {
  const userName = sessionStorage.getItem('userName');
  // Only allow access if user is logged in (has userName)
  return !!userName;
};

const PublishingReviewsDocPreviewer: React.FC<IPublishingReviewsDocPreviewerProps> = (props) => {
  const {
    style,
    className,
    doc_key: docKey,
    doc_name: docName = '',
    doc_suffix: docSuffix = '',
    item_id: itemId,
  } = props;

  const handleNavigatorClick = () => {
    // Store scroll indicator in sessionStorage
    if (itemId) {
      storage.setSessionStorageItem(STRATEGIC_STORAGE_KEY.PUBLISHING_PROJECT_REVIEW_ID, 'true');
    }
    
    // Navigate back with project_id in URL
    const urlParams = itemId 
      ? `tab=publishing&subtitle=publishingProject&project_id=${itemId}`
      : 'tab=publishing&subtitle=publishingProject';
    history.replace(`/strategic/home?${urlParams}`);
  };

  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);

  // Path for this previewer type
  const cosPath = 'mgmt/gbm,mgmt/publishing/project/publishing_reviews';

  return (
    <div style={style} className={classnames('dbs-publishing-reviews-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate: isUseAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(cosPath),
          authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(cosPath),
        }}
        getAuthParams={{}}
        getAuth={getAuth}
        toolbar={<NavigatorToolbar title="Back to Publishing Management" onNavigatorClick={handleNavigatorClick} />}
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default PublishingReviewsDocPreviewer;

